import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import './styles.sass';

const RelatedPosts = ({
  goal: {
    name: goalName,
    urlPath: goalUrl,
    posts: { nodes },
  },
  postId: currentPostId,
}) => {
  return (
    <section className="block block__related-posts">
      <p className="related-posts__category">
        <Link className="text-link" to={goalUrl}>
          {goalName}
        </Link>
      </p>
      <p className="related-posts__header">More like this&hellip;</p>
      <ul className="related-posts__list">
        {nodes
          .filter(({ postId }) => postId !== currentPostId)
          .slice(0, 5)
          .map(
            ({
              postType: {
                nodes: [{ name }],
              },
              title,
              urlPath,
            }) => {
              return (
                <li className="related-posts__list-item" key={urlPath}>
                  <p className="related-posts__category">
                    <span className="visuallyHidden">Post type:</span>
                    {name}
                  </p>
                  <p className="related-posts__title">
                    <Link className="text-link" to={urlPath}>
                      {title}
                    </Link>
                  </p>
                </li>
              );
            }
          )}
      </ul>
    </section>
  );
};

RelatedPosts.propTypes = {
  goal: PropTypes.shape({
    name: PropTypes.string,
    urlPath: PropTypes.string,
    posts: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          postType: PropTypes.shape({
            nodes: PropTypes.arrayOf(
              PropTypes.shape({
                name: PropTypes.string,
              })
            ),
          }),
          title: PropTypes.string,
          urlPath: PropTypes.string,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  postId: PropTypes.number,
};

RelatedPosts.defaultProps = {
  postId: null,
};

export default RelatedPosts;
